import React from 'react'

export default function Section1() {
  return (
    <div className='w-[90%] mx-auto md:pt-[100px] lg:pb-20'>
      <div>
        <p className='text-center text-2xl lg:text-5xl 2xl:text-6xl font-semibold'>About Us</p>
        <p className='text-center text-white mt-3'>GoalDex is a next generation sport platform that integrates blockchain technology, artificial Intelligence (AI), and precision health insights. Designed to connect clubs, players, and investors on a global scale, GoalDex offers a comprehensive ecosystem where talent management, health optimization, and fan engagement come together to create new opportunities for clubs and athletes alike. </p>
      </div>
      <div className='mt-5'>
        <div className='border border-white/10 bg-[#0e0d12] backdrop-blur-[50px] rounded-3xl flex flex-col-reverse lg:flex-row items-center'>
          <div className='lg:w-[60%] flex flex-col gap-4  py-5 px-5'>
            <div className='flex flex-col lg:flex-row items-center justify-between gap-16 lg:gap-24 py-8 px-5 bg-gradient-to-r from-[#262529] via-[#1d1b20] rounded-xl border border-[#2d2b30] to-[#18161b]'>
              <div className='relative  flex justify-start w-[90%] lg:w-[0%]'>
                <p className='text-white 2xl:text-5xl text-4xl lg:-rotate-90 absolute w-20 -translate-y-3 2xl:-translate-y-1'>Vision</p>
              </div>
              <div>
                <p className='2xl:leading-9 leading-5 2xl:text-base lg:text-sm'>GoalDex aims to reinvent the <span className='font-bold text-[#8A55FF]'>soccer recruitment</span> and <span className='font-bold text-[#8A55FF]'>player development ecosystem</span> by providing an all-encompassing platform that combines scientific insights, performance data, and blockchain for data integrity.  </p>
              </div>
            </div>

            <div className='flex flex-col lg:flex-row items-center justify-between gap-16 lg:gap-24 py-8 px-5 bg-gradient-to-r from-[#262529] via-[#1d1b20] rounded-xl border border-[#2d2b30] to-[#18161b]'>
              <div className='relative flex justify-start w-[90%] lg:w-[0%]'>
                <p className='text-white 2xl:text-5xl text-4xl lg:-rotate-90  absolute lg:w-20 2xl:translate-y-3'>Mission</p>
              </div>
              <div>
                <p className='2xl:leading-8 leading-5 2xl:text-base lg:text-sm'>GoalDex is pioneering football recruitment by leveraging blockchain, and <span className='font-bold text-[#8A55FF]'>precision health analytics</span> to build a fully transparent and <span className='font-bold text-[#8A55FF]'>data-driven talent ecosystem</span>. Our mission is to eliminate inefficiencies and intermediaries, enabling direct, merit-based connections between players and clubs. Through <span className='font-bold text-[#8A55FF]'>genetically powered verifiable career data </span>,  and performance optimization, we ensure that every athlete—regardless of background—receives the visibility and opportunities they deserve.</p>
              </div>
            </div>
          </div>
          <div className='lg:w-[40%] flex justify-center'>
            <div className='lg:w-[45%] flex justify-center md:scale-140'>
              <div className='p-5 rounded-full bg-[#B405F3]/5'>
                <div className='p-5 rounded-full bg-[#6A0BF0]/5'>
                  <div className=' rounded-full bg-[#0E0226]'>
                    <img src='/assets/others/Ball.svg' className='border-4 border-[#200758] rounded-full ball-spin-reverse p-2'></img>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
